import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_4 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Due"),
    /*#__PURE__*/_createTextVNode(" History ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Back to List")
const _hoisted_7 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "text-nowrap" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "py-3" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "row invoice-preview"
}
const _hoisted_19 = { class: "col-xl-9 col-md-8 col-12 mb-md-0 mb-4" }
const _hoisted_20 = {
  class: "card invoice-preview-card",
  id: "invoice-container"
}
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "row p-sm-3 p-0" }
const _hoisted_23 = { class: "col-xl-12 col-md-12 col-sm-7 col-12" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "নাম: ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "ফোন :", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "ঠিকানা:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrap text-center" }, " আশা করি আপনি ভাল আছেন। আসছে নতুন বছর, আগামি ২৭,২৮ শে ভাদ্র ১৪২৭ (ইং ১৩ ও ১৪ ই সেপ্টেম্বর) রবিবার ও সোমবার আমাদের দকানে নতুন হালখাতার শুভ উদ্ভদন করা হইবে। উক্ত শুভক্ষণে আপনার উপস্থিত কামনা করা হইল। ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrap text-center" }, " গত বছরে আপনির লেনদেনগুলি আমাদের কাছে গুরুত্বপূর্ণ ছিল, আপনার সর্বমোট লেনদেন এর পরিমান ও বাকির পরিমানের বিবরন নিচে দেওয়া হল। ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_33 = { class: "d-flex py-4 flex-sm-nowrap flex-wrap justify-content-between mt-4" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "border p-3" }
const _hoisted_36 = { class: "text-end mt-4 md-0" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " শুভ কামনা,", -1)
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"row\"><div class=\"col-12\"><span class=\"text-wrap\">Design &amp; Developed by <strong>PhicsArt</strong>!  <img src=\"https://phicsart.com/uploads/images/top-page/menu/logo.svg\" alt=\"\" class=\"img-fluid\" style=\"max-width:13px;\"></span></div></div></div>", 1)
const _hoisted_41 = { class: "col-xl-3 col-md-4 col-12 invoice-actions" }
const _hoisted_42 = { class: "card mb-3" }
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-printer" }),
  /*#__PURE__*/_createTextVNode("   Print A4")
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-download" }),
  /*#__PURE__*/_createTextVNode("   PDF Download")
], -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-label-secondary border d-grid w-100 mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-paper-plane bx-xs me-1" }),
    /*#__PURE__*/_createTextVNode("Send Mail")
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBarView),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: "/due",
                  class: "btn btn-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                              _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                  _createElementVNode("table", null, [
                                                    _createElementVNode("tbody", null, [
                                                      _createElementVNode("tr", null, [
                                                        _hoisted_24,
                                                        _createElementVNode("td", null, [
                                                          _createElementVNode("strong", null, _toDisplayString(_ctx.orderData?.customer?.name), 1)
                                                        ])
                                                      ]),
                                                      _createElementVNode("tr", null, [
                                                        _hoisted_25,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.phone), 1)
                                                      ]),
                                                      _createElementVNode("tr", null, [
                                                        _hoisted_26,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.address), 1)
                                                      ])
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _hoisted_27,
                                            _createElementVNode("div", _hoisted_28, [
                                              _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("p", null, "প্রিয় : " + _toDisplayString(_ctx.orderData?.customer?.name) + ",", 1),
                                                _hoisted_30,
                                                _hoisted_31,
                                                _hoisted_32,
                                                _createElementVNode("div", _hoisted_33, [
                                                  _createElementVNode("div", _hoisted_34, [
                                                    _createElementVNode("span", _hoisted_35, [
                                                      _createElementVNode("strong", null, "সর্বমোট বাকিঃ " + _toDisplayString(Math.abs(_ctx.orderData?.due)) + " টাকা", 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_36, [
                                                    _hoisted_37,
                                                    _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.orderData?.store.name), 1),
                                                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.orderData?.store.address), 1)
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _hoisted_40
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createElementVNode("button", {
                                                class: "btn btn-primary d-grid w-100 mb-3",
                                                "data-bs-toggle": "offcanvas",
                                                "data-bs-target": "#sendInvoiceOffcanvas",
                                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printInvoice('print')))
                                              }, _hoisted_45),
                                              _createElementVNode("button", {
                                                class: "btn btn-label-secondary btn-default border d-grid w-100 mb-3",
                                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadInvoice(_ctx.orderData)))
                                              }, _hoisted_47),
                                              _hoisted_48
                                            ])
                                          ])
                                        ])
                                      ]))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer),
      _hoisted_49
    ])
  ]))
}